import { Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import { parse } from 'qs';
import SwiperCore, { Virtual, A11y, Navigation, SwiperOptions } from 'swiper';

import { splitHttpUri } from '~/attendee/helpers/url/split-http-uri.helper';
import { CategoryCms } from '~/cms/interfaces/homepage.cms.interface';
import { generateUid } from '~/core/helpers/uid/uid.helper';
import { Subscription } from 'rxjs';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { VtmnPlayIconButtonSizeEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayIconButtonVariantEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';

SwiperCore.use([Virtual, Navigation, A11y]);

@Component({
  selector: 'app-attendee-category-collection',
  templateUrl: './category-collection.component.html',
  styleUrls: ['./category-collection.component.scss'],
})
export class AttendeeCategoryCollectionComponent implements OnInit {
  @Input() public categories: CategoryCms[] = [];
  @Input() public title?: string;

  private readonly id = generateUid();
  private readonly subscriptions = new Subscription();

  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayButtonIconVariant = VtmnPlayIconButtonVariantEnum;

  public readonly icon = VtmnPlayIconTypeEnum;
  public isMobileDevice: boolean;

  public config: SwiperOptions = {
    a11y: {
      enabled: false,
    },
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.4,
    spaceBetween: 16,
    keyboard: true,
    mousewheel: { forceToAxis: true },
    scrollbar: false,
    pagination: false,
    navigation: {
      prevEl: `#${this.prevCategoryCollectionButtonId}`,
      nextEl: `#${this.nextCategoryCollectionButtonId}`,
    },
    breakpoints: {
      601: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      900: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1302: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  };

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public getPicture(category: CategoryCms) {
    const activityMediaResolution = category.image?.formats?.xsmall?.url
      ? category.image?.formats?.xsmall.url
      : category.image?.formats?.small?.url || category?.image.url;

    return activityMediaResolution;
  }

  public get nextCategoryCollectionButtonId(): string {
    return `category-collection-next-button-${this.id}`;
  }

  public get prevCategoryCollectionButtonId(): string {
    return `category-collection-prev-button-${this.id}`;
  }

  public getLink(url: string): string {
    // to feed [routerLink] with a beautiful URI without encoded params
    return splitHttpUri(url).uri;
  }

  public getQuery(url: string): Params {
    const splittedUri = splitHttpUri(url);
    if (!splittedUri.params) {
      return;
    }
    return parse(
      splittedUri.params,
      // [queryParams] does not accept neasted parameters, so we have to flatten the request array. (ex: ageRange[gte]=x & ageRange[lte]=y)
      { depth: 0 }
    );
  }
}
